module.exports = __webpack_public_path__ + "static/media/Sidebar__apikey.11f60c2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sidebar__apikey.svg
// module id = 595
// module chunks = 0